import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-dark-950/80 backdrop-blur-md border-b border-white/10 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* 로고 */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/01721397da55af21878e201cee4469af/22d693b8e5c7b9a7815f6764c73619aa.png" 
              alt="CEIS Logo" 
              className="h-10"
            />
          </Link>

          {/* 데스크톱 네비게이션 */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/features" className="text-gray-300 hover:text-white transition-colors">
              기능 소개
            </Link>
            <Link to="/pricing" className="text-gray-300 hover:text-white transition-colors">
              요금제
            </Link>
            <Link to="/certificate-lookup" className="text-gray-300 hover:text-white transition-colors">
              증명서 조회
            </Link>
          </nav>

          {/* 로그인/회원가입 버튼 */}
          <div className="hidden md:flex items-center space-x-4">
            <Link to="/login">
              <button className="text-gray-300 hover:text-white px-4 py-2 rounded-full transition-colors whitespace-nowrap cursor-pointer">
                로그인
              </button>
            </Link>
            <Link to="/register">
              <button className="btn-gradient whitespace-nowrap cursor-pointer">
                무료 체험
              </button>
            </Link>
          </div>

          {/* 모바일 메뉴 버튼 */}
          <button
            className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* 모바일 메뉴 */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/10">
            <div className="flex flex-col space-y-4">
              <Link to="/features" className="text-gray-300 hover:text-white transition-colors">
                기능 소개
              </Link>
              <Link to="/pricing" className="text-gray-300 hover:text-white transition-colors">
                요금제
              </Link>
              <Link to="/certificate-lookup" className="text-gray-300 hover:text-white transition-colors">
                증명서 조회
              </Link>
              <div className="flex flex-col space-y-2 pt-4">
                <Link to="/login">
                  <button className="w-full text-gray-300 hover:text-white px-4 py-2 rounded-full transition-colors whitespace-nowrap cursor-pointer">
                    로그인
                  </button>
                </Link>
                <Link to="/register">
                  <button className="w-full btn-gradient whitespace-nowrap cursor-pointer">
                    무료 체험
                  </button>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
